import React, {useEffect, useState} from 'react';
import {ConfigAddressApi, ConfigApi, OrderType, PlaceApi} from "../../../../../../services/Api/types";
import MultistoreMapPageNavbar from "./Navbar/MultistoreMapPageNavbar";
import MultistoreMapPagePlaceList from "./PlaceList/MultistoreMapPagePlaceList";
import FetchPlaces from "../../../../../../components/Fetch/FetchPlaces";
import ToggleViewButton from "./ToggleViewButton";
import {usePlaceContext} from "../../../../../../services/Place/PlaceContext";
import ChangeLocationMultistoreModal from "../../../HomePage/components/HomeWithMap/Old/ChangeLocationMultistoreModal";
import StringHelper from "../../../../../../services/Common/StringHelper";

const MapComponent = React.lazy(() => import('./Map/MultistoreMapPageMap'));

interface OwnProps {
    config: ConfigApi;
}

const MultistoreMapPageComponent = ({config}: OwnProps) => {
    const [view, setView] = useState<"list" | "map">("map");
    const placesContext = usePlaceContext();
    const [places, setPlaces] = useState<PlaceApi[]>(placesContext.places || []);
    const [selectedOrderType, setSelectedOrderType] = useState<OrderType | undefined>();
    const [selectedPlace, setSelectedPlace] = useState<PlaceApi | undefined>(undefined);
    const [hoveredPlace, setHoveredPlace] = useState<PlaceApi | undefined>(undefined);
    const [showAddressModal, setShowAddressModal] = useState(false);

    useEffect(() => {
        setPlaces(placesContext.places || []);
    }, [placesContext.places]);

    const handleHideLocationModal = (address: ConfigAddressApi) => {
        if (!StringHelper.getAddressName(address)) {
            setSelectedOrderType(undefined);
        }
        setShowAddressModal(false);
    };

    return (
        <div className="multistore-map-page multistore-page">
            <FetchPlaces>
                <MultistoreMapPageNavbar config={config} setShowAddressModal={setShowAddressModal}/>
                <div className={`inner-container ${view === "list" ? "with-list-view" : "with-map-view"}`}>
                    <MultistoreMapPagePlaceList places={places} setSelectedOrderType={setSelectedOrderType}
                                                selectedOrderType={selectedOrderType}
                                                setHoveredPlace={setHoveredPlace}
                                                setShowAddressModal={setShowAddressModal}
                    />
                    <MapComponent view={view} places={places} setSelectedOrderType={setSelectedOrderType}
                                  selectedOrderType={selectedOrderType} selectedPlace={selectedPlace}
                                  setSelectedPlace={setSelectedPlace} hoveredPlace={hoveredPlace}
                                  setShowAddressModal={setShowAddressModal}
                    />
                </div>
                <ToggleViewButton view={view} setView={setView} selectedPlace={selectedPlace}/>
                {
                    showAddressModal &&
                    <ChangeLocationMultistoreModal showModal={showAddressModal}
                                                   onHide={handleHideLocationModal}
                                                   config={config} withoutGeolocation
                                                   onChange={handleHideLocationModal}/>
                }
            </FetchPlaces>
        </div>
    )
}

export default MultistoreMapPageComponent;